document.addEventListener("DOMContentLoaded", () => {
    class SwiperComponent extends HTMLElement {
        constructor() {
            super();
            this.showDesktop = this.getAttribute("show-desktop") !== "false";
            this.showMobile = this.getAttribute("show-mobile") !== "false";
            this.dynamicPagination = JSON.parse(
                this.getAttribute("dynamic-pagination") || "{}"
            );
            this.paginationConfig = JSON.parse(
                this.getAttribute("pagination") || "{}"
            );

            this.init();
            this.observeBodyStyle();
            this.setupVariantDragHandling();
        }

        get _paginationEl() {
            return this.querySelector(".swiper-pagination");
        }

        static hasObserver = false;

        observeBodyStyle() {
            if (SwiperComponent.hasObserver) return;
            SwiperComponent.hasObserver = true;

            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === "style") {
                        const overflowHidden =
                            getComputedStyle(document.body).overflow === "hidden";
                        document.querySelectorAll("swiper-component").forEach((el) => {
                            if (el.swiper) {
                                el.swiper.enabled = !overflowHidden;
                            }
                        });
                    }
                });
            });
            observer.observe(document.body, {
                attributes: true,
                attributeFilter: ["style"],
            });
        }

        setupVariantDragHandling() {
            // 监听 xo-product-variant 元素的拖动事件
            this.addEventListener('mousedown', (e) => {
                const variantElement = e.target.closest('xo-product-variant');
                if (variantElement && this.swiper) {
                    // 禁用 swiper 的触摸/鼠标事件
                    this.swiper.allowTouchMove = false;
                    this.swiper.allowClick = false;
                }
            });

            // 监听鼠标释放事件
            document.addEventListener('mouseup', () => {
                if (this.swiper) {
                    // 重新启用 swiper 的触摸/鼠标事件
                    this.swiper.allowTouchMove = true;
                    this.swiper.allowClick = true;
                }
            });

            // 监听触摸开始事件（移动端）
            this.addEventListener('touchstart', (e) => {
                const variantElement = e.target.closest('xo-product-variant');
                if (variantElement && this.swiper) {
                    // 禁用 swiper 的触摸事件
                    this.swiper.allowTouchMove = false;
                }
            });

            // 监听触摸结束事件（移动端）
            document.addEventListener('touchend', () => {
                if (this.swiper) {
                    // 重新启用 swiper 的触摸事件
                    this.swiper.allowTouchMove = true;
                }
            });
        }

        init() {
            const isDesktop = window.innerWidth >= 750;
            if (
                (isDesktop && !this.showDesktop) ||
                (!isDesktop && !this.showMobile)
            ) {
                this.style.display = "block";
                return;
            }

            // 获取所有 slides
            const slides = this.querySelectorAll('.swiper-slide');
            const slidesCount = slides.length;


            const loopedSlides = this.getAttribute("loopedSlides") || Math.min(slidesCount, 3);
            const isLoop = this.getAttribute("loop") === "true";

            this.style.visibility = 'hidden';

            const swiper = new Swiper(this, {
                slidesPerView: Number(this.getAttribute("slidesPerView")) || 1,
                spaceBetween: Number(this.getAttribute("spaceBetween")) || 0,
                direction: this.getAttribute("direction") || "horizontal",
                speed: Number(this.getAttribute("speed")) || 400,
                loop: isLoop,
                loopedSlides: isLoop ? Number(loopedSlides) : 0,
                grabCursor: isDesktop,
                centeredSlides: this.getAttribute("centeredSlides") === "true",
                autoplay: JSON.parse(this.getAttribute("autoplay")) || false,
                effect: this.getAttribute("effect") || "slide",
                autoHeight: this.getAttribute("autoHeight") === "true",
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                initialSlide: 0,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: `${this.getAttribute("navigationEl")} .swiper-button-next`,
                    prevEl: `${this.getAttribute("navigationEl")} .swiper-button-prev`,
                },
                pagination: {
                    ...this._parsePaginationConfig(),
                },
                breakpoints: JSON.parse(this.getAttribute("breakpoints") || "{}"),
                on: {
                    init: (swiper) => {
                        // 确保在初始化完成后再显示
                        setTimeout(() => {
                            this.style.display = 'block';
                            this.style.visibility = 'visible';
                            if (this._paginationEl) this._paginationEl.style.opacity = '1';
                            if (this.paginationConfig.scroll) this._setupScrollPagination();
                        }, 100);
                    },
                    autoplayTimeLeft: (s, time, progress) => {
                        const activeBullet = this.querySelector(
                            ".swiper-pagination-bullet-active svg"
                        );
                        if (activeBullet) {
                            activeBullet.style.setProperty("--progress", `${1 - progress}`);
                        }
                    },
                    slideChange: (swiper) => {
                        if (this.paginationConfig.scroll)
                            this._handleScrollPaginationOnSlideChange();
                        if (this.dynamicPagination)
                            this._updateDynamicPaginationProperties();
                    },
                },
            });

            this.swiper = swiper;

            if (this.getAttribute("hoverchange") === "true") {
                const bullets = this.querySelectorAll(".swiper-pagination-bullet");
                bullets.forEach((bullet, index) => {
                    bullet.addEventListener("mouseover", () => swiper.slideTo(index));
                });
            }
        }

        _parsePaginationConfig() {
            const { el, clickable, renderBullet, type } = this.paginationConfig;
            if (renderBullet == true) {
                const paginationEls = this.querySelectorAll(
                    ".swiper-pagination-bullet"
                );
                if (paginationEls) {
                    this.paginationConfig.renderBullet = (index, className) => {
                        return `<div class="${className}">${paginationEls[index].innerHTML}</div>`;
                    };
                }
            }
            return {
                el,
                clickable,
                renderBullet: this.paginationConfig.renderBullet,
                type,
            };
        }

        _setupScrollPagination() {
            const scrollPaginationEl = this._paginationEl;
            if (!scrollPaginationEl) return;

            const bullets = scrollPaginationEl.querySelectorAll(
                ".swiper-pagination-bullet"
            );
            const bulletsWidth = Array.from(bullets).reduce(
                (sum, bullet) => sum + bullet.offsetWidth,
                0
            );

            const containerWidth = scrollPaginationEl.offsetWidth;
            if (bulletsWidth > containerWidth) {
                scrollPaginationEl.style.overflowX = "auto";
                scrollPaginationEl.style.justifyContent = "flex-start";
            }
        }

        _handleScrollPaginationOnSlideChange() {
            const paginationEl = this._paginationEl;
            if (!paginationEl) return;

            const activeBullet = paginationEl.querySelector(
                ".swiper-pagination-bullet-active"
            );
            if (!activeBullet) return;

            const { offsetWidth, offsetLeft } = activeBullet;
            const containerWidth = paginationEl.offsetWidth;

            paginationEl.scrollTo({
                left:
                    offsetLeft > containerWidth / 2 ? offsetLeft - offsetWidth / 2 : 0,
                behavior: "smooth",
            });
        }

        _updateDynamicPaginationProperties() {
            const activeBullet = this.querySelector(
                ".swiper-pagination-bullet-active"
            );
            if (!activeBullet) return;

            const { widthProperty, leftProperty } = this.dynamicPagination;

            if (widthProperty) {
                document.documentElement.style.setProperty(
                    widthProperty,
                    `${activeBullet.offsetWidth}px`
                );
            }
            if (leftProperty) {
                document.documentElement.style.setProperty(
                    leftProperty,
                    `${activeBullet.offsetLeft}px`
                );
            }
        }

        disconnectedCallback() {
            this.swiper?.destroy(true, true);
        }

        slideTo(index) {
            if (this.swiper) {
                this.swiper.slideTo(index);
            }
        }
    }
    customElements.define("swiper-component", SwiperComponent);
});

document.addEventListener('shopify:block:select', function (event) {
    hideProductModal();
    const parentSwiperComponent = event.target.closest('swiper-component');
    const closestSlide = event.target.closest('.swiper-slide');
    const slides = Array.from(parentSwiperComponent.querySelectorAll('.swiper-slide'));
    const index = slides.findIndex(slide => slide === closestSlide);
    setTimeout(function () {
        parentSwiperComponent.slideTo(index);
    }, 200);
});